import { Privacy } from "@/pages/legal";
export default Privacy;
